var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "l-header-main__search": true,
        "is-form-visible": _vm.isFormVisible,
        "is-open": _vm.isOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "c-search" },
        [
          _c("AutocompleteForm", {
            attrs: {
              autocompleteUrl: _vm.autocompleteUrl,
              isFormVisible: _vm.isFormVisible,
              isOpen: _vm.isOpen,
              inputPlaceholder: _vm.inputPlaceholder,
            },
            on: {
              "show-form": _vm.showForm,
              "hide-form": _vm.hideForm,
              searched: _vm.setMatches,
            },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _vm._v(" "),
          _vm.isOpen
            ? _c("AutocompleteResults", {
                attrs: {
                  matches: _vm.matches,
                  keyword: _vm.keyword,
                  totals: _vm.totals,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }